// Change #100668 - "gps if possible" on the sign-in log.
//
// Resolves { Latitude, Longitude } ONLY when this browser has already granted
// location to the site; it never shows a permission prompt on the login form.
// Capped at 1.5s (a recent cached fix is fine) and resolves {} on any failure,
// so it can never hold up or break a sign-in.
export const getLoginPositionIfAllowed = async () => {
  try {
    if (typeof navigator === "undefined" || !navigator.geolocation) return {};
    if (!navigator.permissions?.query) return {};
    const permission = await navigator.permissions.query({
      name: "geolocation",
    });
    if (permission?.state !== "granted") return {};
    return await new Promise((resolve) => {
      const timer = setTimeout(() => resolve({}), 1500);
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          clearTimeout(timer);
          resolve({
            Latitude: pos.coords.latitude,
            Longitude: pos.coords.longitude,
          });
        },
        () => {
          clearTimeout(timer);
          resolve({});
        },
        { enableHighAccuracy: false, maximumAge: 10 * 60 * 1000, timeout: 1500 }
      );
    });
  } catch (e) {
    return {};
  }
};
